module.exports = __webpack_public_path__ + "static/media/logo.bdbd08a8.png";